import { PreAssessmentUI } from 'features'

const PreAssessment = () => {
  return (
    <div>
      <PreAssessmentUI/>
    </div>
  )
}

export { PreAssessment }
